import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import gtm from '@/utils/gtm';

const Banner1: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Banner1');

    function handleLink() {
        window.open('https://jp.ecoflow.com/pages/yearend-sale-2025', '_blank');

        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: '詳しくはこちら',
            page_name: 'furusato-tokyo-support-festival',

            __btn_id1: 'banner1-btn',
            __btn_id2: 'banner1-btn',
            __btn_type: 'common',
        });
    }
    return (
        <div className={styles.Banner1 + ' GtmModuleData-section'} data-section-id="banner1">
            <div className="lp-layout">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1765186155839-faoc3d-compressed-PC%20%E6%96%87%E5%AD%97%E4%BF%A1%E6%81%AFbutton%E9%A2%9C%E8%89%B2%E9%A2%84%E8%A7%88.jpg"
                    pad="https://websiteoss.ecoflow.com/figma-uploads/1765186188462-1bjn38-compressed-Mob%20%E6%96%87%E5%AD%97%E4%BF%A1%E6%81%AFbutton%E9%A2%9C%E8%89%B2%E9%A2%84%E8%A7%88.jpg"
                    isOpenLazy={true}
                />

                <div className="banner1-content">
                    <div className="title">EcoFlow年末年始キャンペーン</div>
                    <div className="subtitle">最大63%OFF</div>
                    <div className="description">想う人へ、安心というおくりもの。</div>
                    <div className="period">開催期間：12/15（月）〜1/4（日）</div>
                    <div className="button GtmModuleData-btn-common banner1-btn" data-btn-id="banner1-btn" onClick={() => handleLink()}>
                        詳しくはこちら
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner1;
